"use client";
import { motion } from "framer-motion";
import { Card, CardContent, Typography, Box } from "@mui/material";

interface AnimatedCardProps {
  title: string;
  description: string;
  icon: string;
}

export default function AnimatedCard({
  title,
  description,
  icon,
}: AnimatedCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ fontSize: "2.5rem", mb: 2, textAlign: "center" }}>
            {icon}
          </Box>
          <Typography variant="h6" component="h3" gutterBottom align="center">
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ flexGrow: 1 }}
          >
            {description}
          </Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
}
